import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import StageLighting from './components/StageLighting';

// Lazy load pages
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Services = lazy(() => import('./pages/Services'));
const GearVault = lazy(() => import('./pages/GearVault'));
const Booking = lazy(() => import('./pages/Booking'));
const Contact = lazy(() => import('./pages/Contact'));
const ReviewsPage = lazy(() => import('./pages/Reviews'));
const Admin = lazy(() => import('./pages/Admin'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const Footer = lazy(() => import('./components/Footer'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-studio-dark">
    <div className="w-12 h-12 border-4 border-electric-blue border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-studio-dark text-white selection:bg-electric-blue selection:text-studio-dark font-sans flex flex-col relative overflow-x-hidden">
        <StageLighting />
        <Header />
        <main className="flex-grow relative z-10">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutLayout><About /></AboutLayout>} />
              <Route path="/services" element={<AboutLayout><Services /></AboutLayout>} />
              <Route path="/gear" element={<AboutLayout><GearVault /></AboutLayout>} />
              <Route path="/booking" element={<AboutLayout><Booking /></AboutLayout>} />
              <Route path="/contact" element={<AboutLayout><Contact /></AboutLayout>} />
              <Route path="/reviews" element={<AboutLayout><ReviewsPage /></AboutLayout>} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<AboutLayout><PrivacyPolicy /></AboutLayout>} />
              <Route path="/terms" element={<AboutLayout><TermsConditions /></AboutLayout>} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </Router>
  );
}

const AboutLayout = ({ children }) => (
  <>
    {children}
    <Suspense fallback={null}>
      <Footer />
    </Suspense>
  </>
);

export default App;